<div class="overlay" *ngIf="showTooltip" (click)="clickOverlay()"></div>

<div class="spaceTooltip">
	<ui-common-info-svg class="spaceTooltip__icon" (click)="openTooltip()"></ui-common-info-svg>
	<div class="boxTooltip" *ngIf="showTooltip" [ngStyle]="tooltipStyles"><ng-content></ng-content></div>
</div>
